import React, { useEffect, useState } from 'react'
import { ModalWrapper } from '../wrapperComponents/page'
import formatMsg from '../../util/formatMsg'
import { Form } from 'antd'
import FormWrapper from '../formWrapper/page'
import { timeutil } from '../..'

type TncModalProps = {
    termsVisible: any;
    showHideTermsAndConditions: any;
    termsAndConditions: string;
    buttonText: string;
    firebase: any;
    signatureRefs?: any;
    createBooking?: any
    isLoading?: any; // ✅ fixed this line
    acknowledgementFields?: any; // ✅ optional prop
    viewMode?: boolean;
    setViewMode?: any
};

const TncModal: React.FC<TncModalProps> = ({ termsVisible, showHideTermsAndConditions, termsAndConditions, buttonText, firebase, signatureRefs, createBooking, isLoading, acknowledgementFields, viewMode, setViewMode }) => {
    const [form] = Form.useForm();
    const [isFormValid, setIsFormValid] = useState(false);
    const [signChange, setSignChange] = useState<any>(false);

    useEffect(() => {
        if (acknowledgementFields)
            checkFormValidity();
    }, [acknowledgementFields, signChange]);

    const onFinish = () => {
        acknowledgementFields?.map((field) => {
            let fieldObj = field[0];
            if (fieldObj.type === "signature") {
                form.setFieldValue(fieldObj.name,
                    getSignatureData(fieldObj.name)
                )
            }
        })
        form.validateFields()
            .then((values) => {
                const payload = [];

                let hasError = false;
                const customErrors = [];

                acknowledgementFields?.forEach((field) => {
                    const fieldObj = field[0];
                    const value = fieldObj.type == "date" ? timeutil.getEpoch(values[fieldObj.name]) : values[fieldObj.name];
                    const requiredValue = fieldObj.requiredValue;
                    if (
                        requiredValue !== undefined &&
                        requiredValue !== null &&
                        value &&
                        value !== requiredValue
                    ) {
                        hasError = true;
                        customErrors.push({
                            name: [fieldObj.name],
                            errors: [`${formatMsg("ackfields.warings", { requiredValue: fieldObj.type == "date" ? timeutil.inFormat(requiredValue) : requiredValue })}`],
                        });
                    } else {
                        payload.push({
                            label: fieldObj.name,
                            type: fieldObj.type,
                            value: value
                        });
                    }
                });

                if (hasError) {
                    form.setFields(customErrors);
                    return;
                }

                createBooking(payload);
            });
    };

    const getSignatureData = (fieldName) => {
        return signatureRefs?.current?.[fieldName]?.current?.isEmpty() ? null : (signatureRefs?.current?.[fieldName]?.current?.toDataURL() || null);
    };

    const checkFormValidity = () => {
        const allFields = form.getFieldsValue();
        const flatFields = acknowledgementFields.flat();
        const requiredFields = flatFields
            .filter(field => field.required || field.requiredValue)
            .map(field => field);
        // Check if all required fields are non-empty
        let allFilled = true;
        if (requiredFields?.length) allFilled = requiredFields.every(field => {
            if (field.type === "signature") {
                return Boolean(getSignatureData(field.name));
            }
            if (field.type === "date" && field.requiredValue) {
                return allFields[field.name] && timeutil.isSame(timeutil.getInstance(field.requiredValue).startOf("day"), allFields[field.name].startOf("day"), 'day');
                // return timeutil.getInstance(field.requiredValue).isSame(timeutil.getInstance(allFields[field.name]), 'day');
            }
            const value = allFields[field.name];
            if (field.requiredValue || field.requiredValue == false || field.requiredValue == 0) {
                return value == field.requiredValue;
            }
            return true;
        });
        setIsFormValid(allFilled);
    };
    return (
        <ModalWrapper
            open={termsVisible}
            title={formatMsg("label.termsAndConditions")}
            onOk={onFinish}
            onCancel={() => {
                showHideTermsAndConditions()
                setViewMode && setViewMode(false)
            }}
            okText={buttonText}
            maskClosable={false}
            cancelButtonProps={{ style: { display: 'none' } }}
            okButtonProps={{ style: { display: !viewMode ? null : "none" }, disabled: !isFormValid }}
            confirmLoading={isLoading}
            width={600}
        >
            <div className={!viewMode ? 'tnc-text' : 'view-tnc-text'} dangerouslySetInnerHTML={{ __html: termsAndConditions }} />
            {
                !viewMode &&
                <div className='ack-margintop'>
                    <Form
                        form={form}
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        onValuesChange={checkFormValidity}
                    >
                        <FormWrapper
                            formFields={acknowledgementFields}
                            firebase={firebase}
                            signChange={setSignChange}
                        />
                    </Form>
                </div>}
        </ModalWrapper>
    )
}

export default TncModal